import React from 'react';

const userContext = React.createContext({
   accountNumber:"",
   streetNumber:"",
   streetName: "",
   streetType: "",
   unitNumber:"",
   locationId:"",
   token:"",
   fullAddress:"",
   requestType: [],
   isAuthenticated: false,
   setUserDetails: () => {},
   setSFToken: () => {}
});

export default userContext;